module.exports = __webpack_public_path__ + "static/media/green.d243e621.png";